import Vue from 'vue'

// Filters
import './filters'

// ThinkMD Components
import './components'

// Application imports
import App from './App'
import router from '@/router'

// Pinia
import pinia from '@/stores'

// Plugins
import { i18n } from '@/plugins/i18n'
import { vuetify } from '@/plugins/vuetify'
import '@/plugins/headful'
import '@/plugins/offline'
import '@/plugins/sentry'
import AnalyticsService from './plugins/analytics'
import FeatureFlagsPlugin from '@/config/featureFlags'
import { initLifecycleLogging } from '@/logging/lifecycle'
import { logger } from '@/logging/logger'

Vue.use(AnalyticsService)
Vue.use(FeatureFlagsPlugin)

Vue.config.productionTip = false

const previousErrorHandler = Vue.config.errorHandler
Vue.config.errorHandler = function(err, vm, info) {
    logger.error(
        'app.lifecycle',
        'error.unhandled.vue',
        {
            info,
            component: vm?.$options?.name,
            message: err?.message,
        },
        'Unhandled Vue error',
    ).then()

    if (typeof previousErrorHandler === 'function') {
        previousErrorHandler(err, vm, info)
    }
}

initLifecycleLogging()

Vue.filter('capitalize', function(value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})


/* eslint-disable no-new */
window.App = new Vue({
    el: '#app',
    i18n,
    router,
    pinia,
    template: '<App/>',
    vuetify,
    render: h => h(App)
}).$mount('#app')
